/* eslint-disable eslint-comments/disable-enable-pair -- needed */
/* eslint-disable arrow-parens -- needed */
/* eslint-disable unicorn/no-nested-ternary -- needed */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types -- needed */
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const MIN_WIDTH_MID_SCREEN = 1024;

export const layoutTypeResolver = (showMobileTileView, isListView) => (
  showMobileTileView
    ? 'mobile'
    : isListView ? 'list'
      : 'grid');

export const enrollButtonClassNameResolver = isGrid => (isGrid
  ? 'margin-auto-lr'
  : 'margin-auto-lr');

export const learnMoreButtonClassNameResolver = isGrid => (isGrid
  ? 'margin-auto-lr'
  : 'margin-auto-lr');

export const getEnrollButtonLink = (isThirdParty, pageLink) => {
  let nonThirdPartyLink = '';
  if (global.BROWSER) {
    nonThirdPartyLink = `${window.location.origin}/card-benefits/${pageLink}`;
  }

  return isThirdParty ? pageLink : nonThirdPartyLink;
};

export const getDisclosureHeading = (type) => {
  let heading = <FormattedMessage id="shared.terms-links.benefits-terms" defaultMessage="‡Benefit Terms" />;
  if (type === 'ASSURANCE_DISCLOSURES') {
    heading = '♦Amex Assurance Disclosures';
  }
  return heading;
};

export const concatDisclosures = (disclosures) => {
  if (disclosures.length > 0) {
    let multiDisclosures = '';
    let disclosureHeading = '';
    disclosures.forEach((disclosure) => {
      disclosureHeading = !disclosure?.title ? disclosure?.header : disclosure?.title;
      multiDisclosures += `<h4 class="font-weight-bold">${disclosureHeading && disclosureHeading}</h4><br />${disclosure.content}<br /><br />`;
    });
    return multiDisclosures;
  }
  return '';
};

// Checks if the url begins with https if not, it is added
export const ctaProtocolCheck = (url) => {
  const urlPrefix = 'https://';
  const telPrefix = 'tel:';
  if (!url) {
    return undefined;
  }
  if (url.slice(0, telPrefix.length) === telPrefix) {
    return url;
  }
  if (url.slice(0, urlPrefix.length) !== urlPrefix) {
    return urlPrefix + url;
  }
  return url;
};

export const CardBenefitsTilePropTypes = {
  isLoading: PropTypes.func,
  loadedWithErrors: PropTypes.func,
  benefitName: PropTypes.string,
  benefitTitle: PropTypes.string,
  isListView: PropTypes.bool,
  benname: PropTypes.string,
  cardname: PropTypes.string,
  login: PropTypes.bool,
  isEnrollable: PropTypes.bool,
  enrollmentDetails: PropTypes.shape({
    enrollmentStatus: PropTypes.string,
    statusDate: PropTypes.string,
    membershipNumber: PropTypes.string,
  }),
  tracker: PropTypes.shape({
    type: PropTypes.string,
    disclaimer: PropTypes.string,
  }),
  summary: PropTypes.shape({
    layout: PropTypes.shape({
      callToAction: PropTypes.shape({
        isThirdParty: PropTypes.bool,
        text: PropTypes.string,
        link: PropTypes.string,
      }),
    }),
    marketingText: PropTypes.shape({
      copy: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired,
      thumbnailImage: PropTypes.string.isRequired,
      terms: PropTypes.string.isRequired,
      disclaimer: PropTypes.string.isRequired,
    }).isRequired,
  }),
  detail: PropTypes.shape({
    layout: PropTypes.shape({
      webFormat: PropTypes.string.isRequired,
      callToAction: PropTypes.shape([
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          type: PropTypes.string.isRequired,
          destinationType: PropTypes.string.isRequired,
          link: PropTypes.string.isRequired,
        }),
      ]),
    }).isRequired,
  }),
  displayStatus: PropTypes.shape({
    label: PropTypes.string.isRequired,
    showMembership: PropTypes.string.isRequired,
  }),
  showMobileTileView: PropTypes.bool.isRequired,
  IMAGE_DOMAIN: PropTypes.string,
  view: PropTypes.string,
};
